module.exports = __webpack_public_path__ + "static/media/TH9.3dd9d677.jpg";